module.exports = __webpack_public_path__ + "static/img/upload_success.224bd73e.png";